<!-- 안전리더십 > 컨텐츠수행 > 메인팝업 -->
<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="94rem"
      class="layer-popup sl-pop1"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{taskItems.taskTitle}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <div class="pop-cont">
          <div class="tab-group">
            <v-tabs
              v-model="popupTab"
            >
              <template v-for="(item, index) in taskItems.contentList">
                <v-tab :value="'tabCont'+(index+1)" v-if="(isContentUser(item) || isObserver)">{{item.contentTitle??''}}{{!utils.isEmpty(item.targetInfo)?`(${item.targetInfo})`:''}}</v-tab>
              </template>
            </v-tabs>
          </div>
        </div>
        <v-card-text>
          <v-tabs-window v-model="popupTab">
            <v-tabs-window-item v-for="(item, index) in taskItems.contentList" :value="'tabCont'+(index+1)">
              <DialogSLR101 v-if="item.contentType=='1'" :item="item" :ref="el => setChildRef(el, index)" :is-active="popupTab === 'tabCont'+(index+1)" @complete="onComplete" @save="onCloseAfterSave"/>
              <DialogSLR104 v-if="item.contentType=='2'" :item="item" :ref="el => setChildRef(el, index)" :is-active="popupTab === 'tabCont'+(index+1)" @complete="onComplete" @save="onCloseAfterSave"/>
              <DialogSLR102 v-if="item.contentType=='3'||item.contentType=='4'" :item="item" :ref="el => setChildRef(el, index)" :is-active="popupTab === 'tabCont'+(index+1)" @complete="onComplete" @save="onCloseAfterSave"/>
              <!-- <DialogSLR103/> -->
            </v-tabs-window-item>
          </v-tabs-window>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end" v-if="!isObserver">
          <c-btn01 :btnText="buttonTxt" @click="onClickSave" v-if="!isComplete"/>
          <c-btn02 :btnText="t('message.submitCompleted')" v-show="false"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import utils from "@/common/Utils";
import _ from 'lodash';
const { t } = useI18n();

//define
const emit = defineEmits(['refresh'])

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const dialog = defineModel()

//bind
const snackbar = ref(false)
const snackText = ref('')
const route = useRoute()
const taskItems:any = ref({})
const contentItems:any = ref({})
const childRefs = ref([])
const popupTab = ref('')
const isComplete = ref(false)
const buttonTxt = ref(t('message.submitLS'))
const userInfo = JSON.parse(localStorage.getItem('user'))
const isObserver = ref(false)

//hook
onMounted(() => {
})

//function
const onClickSave=()=>{
  const index = Number(popupTab.value.slice(-1))
  childRefs.value[index-1].childRefSave()
}

const onComplete=(done, isFileUpload)=>{
  isComplete.value = done
  emit('refresh', true)
  if(isFileUpload)  //자유형식 완료됐는데 파일제출여부Y면 파일은 업로드할 수 있게 변경
    buttonTxt.value = t('message.uploadFile')
}

const onCloseAfterSave=()=>{
  if(taskItems.value.contentList?.length <= 1)
    dialog.value = false
}

function setChildRef(el, index) {
  if (el)
    childRefs.value[index] = el
}

const childRefLoadData=()=>{
  taskItems.value = storeRef.selectedTask.value
  contentItems.value = storeRef.selectedContent.value
  if(!utils.isEmpty(contentItems.value)) {
    const contentIndex = _.findIndex(taskItems.value.contentList, contentItems.value)
    popupTab.value = 'tabCont'+(contentIndex+1)
  }
}

//상세내역 참여자인지 확인
const isContentUser=(item)=>{
  //타인관찰 아니면
  if(item.contentType != '4' && item.leadershipTargetIdx == userInfo.memberIdx)
    return true
  //타인관찰이고, 리더십 내부관찰자면 두값모두있어야되고, 리더십 외부 관찰자면 1번은 널 2번은 있어야함
  else if(item.contentType == '4' && ((item.leadershipTargetIdx == userInfo.memberIdx && item.monitoringTargetIdx == userInfo.memberIdx) || (!item.leadershipTargetIdx && item.monitoringTargetIdx == userInfo.memberIdx)))
    return true
  else
    return false
}

//watch
watch(popupTab, (newData, oldData) => {
  const tabNumber = Number(newData?.match(/\d+$/)?.[0])
  contentItems.value = taskItems.value.contentList[tabNumber-1]
  if(contentItems.value.contentType=='1')
    buttonTxt.value = t('message.confirm')+'/'+t('message.submitLS')
  else
    buttonTxt.value = t('message.submitLS')

  isObserver.value = storeRef.isObserver.value
})

defineExpose({
  childRefLoadData,
})
</script>


<style lang="scss" scoped>
</style>
